import { useContext } from 'react';
import { RuntimeConfigContext } from './RuntimeConfigContext';
import type { RuntimeConfig } from './runtimeConfig';

export function useRuntimeConfig(): RuntimeConfig {
    const config = useContext(RuntimeConfigContext);
    if (!config) {
        throw new Error('useRuntimeConfig() called outside <ConfigProvider>');
    }
    return config;
}
